module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige1-c24b0296e85571fc6395f434a25338a3.jpg";